import React, { Component } from 'react';
import PropTypes from 'prop-types';

export default class Calendar extends Component {
  static propTypes = {
    height: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    width: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    iconColor: PropTypes.string,
    disabled: PropTypes.bool
  };

  static defaultProps = { height: 50, width: 50, disabled: false, iconColor: null };

  render() {
    const { height, width, iconColor, disabled } = this.props;

    return (
      <svg viewBox="0 0 160 160" width={width} height={height} version="1.1" xmlns="http://www.w3.org/2000/svg">
        <g fill="none" fillRule="evenodd">
          <path
            className="st0"
            d="M100.45,143.52c-0.71,0-1.34,0-1.96,0c-25.66,0-51.32,0.01-76.98-0.01c-11.71-0.01-20.28-8.43-20.3-20.09
			c-0.05-24.9-0.02-49.8-0.01-74.7c0-0.44,0.04-0.88,0.06-1.48c43.8,0,87.55,0,131.55,0c0.03,0.6,0.11,1.27,0.11,1.93
			c0.01,17.94,0.02,35.88-0.05,53.82c0,1-0.53,2.24-1.24,2.95c-9.1,9.22-18.25,18.4-27.48,27.5c-1.54,1.52-2.48,3.12-2.73,5.25
			C101.22,140.27,100.8,141.81,100.45,143.52z M30.91,110.37c0,3.13-0.02,6.25,0.01,9.38c0.02,2.86,1.48,4.44,4.33,4.47
			c6.32,0.06,12.63,0.06,18.95-0.01c2.74-0.03,4.28-1.56,4.31-4.31c0.06-6.32,0.06-12.63,0-18.95c-0.03-2.63-1.54-4.22-4.17-4.26
			c-6.44-0.08-12.89-0.08-19.33,0.01c-2.67,0.04-4.05,1.61-4.08,4.29C30.89,104.12,30.92,107.25,30.91,110.37z M75.71,110.28
			c0,3.13-0.02,6.25,0,9.38c0.02,3.03,1.41,4.54,4.4,4.57c6.25,0.06,12.5,0.06,18.75,0c2.82-0.03,4.4-1.59,4.43-4.42
			c0.07-6.25,0.06-12.51,0-18.76c-0.03-2.75-1.54-4.32-4.27-4.36c-6.38-0.08-12.76-0.08-19.14,0.01c-2.78,0.04-4.14,1.59-4.17,4.4
			C75.69,104.15,75.71,107.22,75.71,110.28z M89.38,85.93c3.13,0,6.26,0.03,9.38-0.01c2.97-0.04,4.51-1.51,4.54-4.48
			c0.06-6.19,0.06-12.38,0-18.58c-0.03-2.84-1.62-4.37-4.44-4.38c-6.25-0.03-12.51-0.03-18.76,0c-2.88,0.01-4.36,1.51-4.38,4.38
			c-0.03,6.19-0.03,12.38,0,18.58c0.01,3,1.45,4.44,4.47,4.48C83.25,85.96,86.32,85.93,89.38,85.93z M44.67,85.93
			c3.06,0,6.13,0.03,9.19-0.01c3.12-0.03,4.62-1.47,4.64-4.56c0.04-6.13,0.05-12.26,0-18.39c-0.02-2.95-1.58-4.48-4.52-4.5
			c-6.19-0.03-12.38-0.03-18.57,0c-3.01,0.01-4.48,1.49-4.49,4.46c-0.02,6.19-0.02,12.39,0,18.58c0.01,2.87,1.47,4.35,4.37,4.4
			C38.41,85.97,41.54,85.93,44.67,85.93z"
            fill={disabled ? '#D8D8D8' : iconColor}
          />
          <path
            className="st0"
            d="M87.93,11.37c0.02,3.96,0.04,7.91,0.07,11.87c0.02,2.86,1.52,4.66,3.9,4.71c2.46,0.05,4.09-1.76,4.11-4.72
			c0.04-3.82,0.01-7.63,0.01-11.32c0.32-0.18,0.43-0.3,0.54-0.3c6.5,0.06,13.04-0.22,19.51,0.29c9.08,0.72,16.44,8.9,16.77,18.01
			c0.11,2.93,0.02,5.86,0.02,8.96c-43.87,0-87.66,0-131.64,0c0.05-5.01-0.55-9.97,1.32-14.77c2.99-7.7,10.06-12.46,18.83-12.55
			c5.61-0.06,11.23-0.07,16.84-0.11l-0.07-0.06c0.02,3.95,0.03,7.9,0.05,11.86c0.02,2.89,1.48,4.66,3.87,4.72
			c2.48,0.06,4.09-1.71,4.12-4.7c0.05-3.81,0.01-7.63,0.01-11.71c0.94,0,1.68,0,2.42,0c12.36,0,24.73,0,37.09-0.01
			c0.76,0,1.52-0.07,2.28-0.11L87.93,11.37z"
            fill={disabled ? '#D8D8D8' : iconColor}
          />
          <path
            className="st0"
            d="M134.05,115.02c4.91,4.96,9.8,9.88,14.88,15.01c-0.96,0.9-2.05,1.87-3.08,2.9
			c-6.78,6.76-13.53,13.56-20.35,20.28c-0.72,0.71-1.77,1.24-2.76,1.47c-3.6,0.81-7.24,1.47-10.87,2.17
			c-3.25,0.62-5.54-1.64-4.92-4.9c0.72-3.82,1.46-7.64,2.26-11.44c0.12-0.59,0.45-1.21,0.88-1.64c7.83-7.88,15.7-15.73,23.56-23.58
			C133.77,115.16,133.95,115.08,134.05,115.02z"
            fill={disabled ? '#D8D8D8' : iconColor}
          />
          <path
            className="st0"
            d="M154.93,124c-5.13-5.11-10.04-10.01-15.02-14.98c2.14-2.43,4.33-4.87,8.16-3.73c0.83,0.25,1.7,0.65,2.32,1.24
			c2.32,2.18,4.62,4.4,6.78,6.74c2.26,2.45,2.16,5.81-0.05,8.34C156.42,122.43,155.67,123.21,154.93,124z"
            fill={disabled ? '#D8D8D8' : iconColor}
          />
          <path
            className="st0"
            d="M88,11.43c0.04-1.4,0.06-2.79,0.12-4.19c0.1-2.43,1.66-4.14,3.81-4.19C94.14,3,95.7,4.61,95.8,7.11
			c0.05,1.33,0.01,2.66,0.01,4.26c-2.71,0-5.29,0-7.87,0C87.93,11.37,88,11.43,88,11.43z"
            fill={disabled ? '#D8D8D8' : iconColor}
          />
          <path
            className="st0"
            d="M38.22,11.44c0.03-1.4,0.04-2.79,0.09-4.19c0.08-2.46,1.61-4.15,3.78-4.19c2.21-0.05,3.79,1.56,3.89,4.04
			c0.06,1.33,0.01,2.66,0.01,4.28c-2.68,0-5.26,0-7.83,0C38.15,11.38,38.22,11.44,38.22,11.44z"
            fill={disabled ? '#D8D8D8' : iconColor}
          />
          <path
            className="st0"
            d="M50.42,104.78c0,3.82,0,7.5,0,11.36c-3.76,0-7.48,0-11.36,0c0-3.74,0-7.47,0-11.36
			C42.78,104.78,46.5,104.78,50.42,104.78z"
            fill={disabled ? '#D8D8D8' : iconColor}
          />
          <path
            className="st0"
            d="M83.69,104.71c4,0,7.67,0,11.47,0c0,3.82,0,7.56,0,11.57c-3.54,0-7.09,0.02-10.64-0.05
			c-0.28-0.01-0.79-0.65-0.8-1.01C83.67,111.79,83.69,108.35,83.69,104.71z"
            fill={disabled ? '#D8D8D8' : iconColor}
          />
          <path
            className="st0"
            d="M95.18,77.91c-3.89,0-7.55,0-11.37,0c0-3.82,0-7.53,0-11.38c3.82,0,7.54,0,11.37,0
			C95.18,70.34,95.18,74.06,95.18,77.91z"
            fill={disabled ? '#D8D8D8' : iconColor}
          />
          <path
            className="st0"
            d="M38.93,77.89c0-3.6-0.02-7.09,0.04-10.58c0.01-0.3,0.62-0.85,0.95-0.85c3.43-0.06,6.87-0.04,10.43-0.04
			c0,3.9,0,7.63,0,11.48C46.64,77.89,42.97,77.89,38.93,77.89z"
            fill={disabled ? '#D8D8D8' : iconColor}
          />
        </g>
      </svg>
    );
  }
}
